import type { Area } from '@common/types/Area'
import type { Journey } from '@common/types/Journey'
import type { Stop } from '@common/types/Stop'
import type { LatLng } from '@lc/libmap-types'
import type { ModuleObject } from './modules'

export function getSortedJourneys(
	journeys: Journey[],
	currentModule: ModuleObject,
) {
	return [...journeys].filter(journey => {
		switch (currentModule.mode) {
			case 'all':
				return true

			case 'public-transport':
				return journey.sections.some(
					section => section.type === 'public-transport',
				)

			case 'walk':
				return journey.sections.every(
					section => section.type === 'walk',
				)

			case 'bike':
				return journey.sections.some(section => section.type === 'bike')

			default:
				return journey.sections.some(
					section => section.type === currentModule.mode,
				)
		}
	})
}

export function parseLatLng(param: string | null): LatLng | null {
	try {
		return (param?.split(';').map(x => parseFloat(x)) as LatLng) ?? null
	} catch {
		console.error('parseLatLng >> error parsing parameter:', param)
		return null
	}
}

export function sortRules(a: Journey, b: Journey) {
	const arrivalDateA = new Date(a.arrival).getTime()
	const arrivalDateB = new Date(b.arrival).getTime()

	if (arrivalDateA === arrivalDateB) {
		return new Date(b.departure).getTime() - new Date(a.departure).getTime()
	}

	return arrivalDateA - arrivalDateB
}

export function determineTypeStop(pt: Stop | Area): pt is Stop {
	return 'stopArea' in pt
}
